<template>
  <div>
    <cube-input
      class="input-style"
      v-bind="inputAttrs"
      v-on="$listeners"
    >
    </cube-input>
    <div :class="{'disabled': !syncCodeVisible, 'grey': isGrey, [codeClass]: codeClass }" @click="getCode">
      <span v-if="syncCodeVisible">{{ getCodeText || '获取验证码' }}</span>
      <span v-else>{{syncTime}}s</span>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    getCodeText: {
      type: String,
    },
    time: {
      type: Number,
      default: 60,
    },
    codeVisible: {
      type: Boolean,
      default: false,
    },
    inputAttrs: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isGrey: {
      type: Boolean,
      default: true,
    },
    codeClass: {
      type: String,
      default: 'code'
    }
  },
  data() {
    return {
    }
  },
  computed: {
    syncTime: {
      get() {
        return this.time
      },
      set(value) {
        this.$emit('update:time', value)
      }
    },
    syncCodeVisible: {
      get() {
        return this.codeVisible
      },
      set(value) {
        this.$emit('update:codeVisible', value)
      }
    }
  },
  methods: {
    getCode() {
      if (!this.syncCodeVisible) {
        return
      }
      this.$emit('getCode', this.timesHandle)
    },
    timesHandle() {
      window.clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.syncTime--
        if (this.syncTime <= 0) {
          this.syncCodeVisible = true
          this.syncTime = 60
          window.clearInterval(this.timer)
        }
      }, 1000)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "common-css/mixins.scss";

.code {
  position: absolute;
  right: px2rem(10);
  top: px2rem(20);
  min-width: px2rem(160);
  font-family: PingFangSC-Regular;
  font-size: px2rem(28);
  color: #333;
  border-radius: px2rem(8);
  padding: px2rem(10) 0;
  width: 80px;
  text-align: center;
  border: 1px solid #434553;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  line-height: 1.1;
}
.grey,.disabled {
  border-color: #ccc;
  background: #ccc;
  color: #fff;
}
</style>
